import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' }); // for instant scroll
  }, [pathname]);

  return null;
}
